import React from 'react';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import { isIOS } from 'react-device-detect';
import StarryBackground from './StarryBackground';
import { useI18n } from '../i18n';

const LandingPage = ({ 
  primaryAction, 
  secondaryAction, 
  deepLinkType, 
  deepLinkData, 
  isAppInstalled, 
  deviceType 
}) => {
  const { t } = useI18n();

  return (
    <>
      <Helmet>
        <title>{t('seo.default_title')}</title>
        <meta name="description" content={t('seo.default_desc')} />
        <meta property="og:title" content={t('seo.default_title')} />
        <meta property="og:description" content={t('seo.default_desc')} />
        <meta property="og:url" content={window.location.href} />
      </Helmet>

      {/* Sfondo stellato animato */}
      <StarryBackground />

      {/* Contenuto principale */}
      <div className="sora-layout">
        {/* Header */}
        <motion.header 
          className="sora-header"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <div className="sora-header-content">
            <div className="sora-logo-text">
              <img src="/wanderbuddy-white.png" alt="WanderBuddy" style={{ height: '32px', width: 'auto' }} />
            </div>
            <div className="sora-header-actions">
              <motion.a
                href="https://apps.apple.com/app/id6737308693"
                className="sora-btn sora-btn-download"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                {t('landing.cta_store')}
              </motion.a>
              <motion.button
                className="sora-btn sora-btn-login"
                disabled
                style={{ opacity: 0.5, cursor: 'not-allowed' }}
              >
                Login
              </motion.button>
            </div>
          </div>
        </motion.header>

        {/* Contenuto centrale */}
        <motion.main 
          className="sora-main"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.8 }}
        >
          {/* App Icon */}
          <motion.div 
            className="sora-app-icon"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ delay: 0.4, duration: 0.6 }}
          >
            <img src="/app-icon.png" alt="WanderBuddy" />
          </motion.div>

          {/* Hero Text */}
          <motion.h1 
            className="sora-title"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5, duration: 0.6 }}
          >
              {t('landing.title')}
          </motion.h1>

          <motion.p 
            className="sora-description"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.6, duration: 0.6 }}
          >
            {t('landing.desc1')}<br />
            {t('landing.desc2')}
          </motion.p>

          <motion.p 
            className="sora-tagline"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.7, duration: 0.6 }}
          >
            {t('landing.tagline')}
          </motion.p>

          {/* Action Buttons */}
          <motion.div 
            className="sora-actions"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.8, duration: 0.6 }}
          >
            <motion.a
              href="https://apps.apple.com/app/id6737308693"
              className="sora-appstore-btn"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <img 
                src="/app-store-badge.svg" 
                alt="Download on the App Store" 
                style={{ height: '48px', width: 'auto' }}
              />
            </motion.a>
            
            <motion.a
              href={isIOS ? "https://wanderbuddy.it" : "/waitlist"}
              className="sora-research-btn"
              target={isIOS ? "_blank" : "_self"}
              rel={isIOS ? "noopener noreferrer" : ""}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              {isIOS ? 'Read the research' : t('landing.cta_waitlist')}
            </motion.a>
          </motion.div>
        </motion.main>

        {/* Footer */}
        <motion.footer 
          className="sora-footer"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1, duration: 0.6 }}
        >
          {t('common.footer')}
        </motion.footer>
      </div>
    </>
  );
};

export default LandingPage;
